import { actions } from "@ehi/global-marketing-interface";

export const upgradeCarClass = (carClassCode) => (dispatch) =>
    dispatch(actions.reservations.upgradeCarClass(carClassCode));